interface IDividerProps {
  className?: string;
}
const Divider = ({ className }: IDividerProps) => {
  return (
    <div
      className={"h-px w-full bg-mid-grey-40 " + className}
      data-testid="divider"
    ></div>
  );
};

export default Divider;
